import {h} from "vue";
import {RouterLink} from "vue-router";
import {NIcon} from "naive-ui";


export function renderIcon(icon) {
    return () => h(NIcon, {size: "22px"}, { default: () => h(icon) });
}

export function renderRouteLabel(to, label, key, icon) {
    return {
        label: () =>
            h(
                RouterLink,
                {
                    to: to
                },
                { default: () => label }
            ),
        key: key,
        icon: renderIcon(icon)
    }
}
